













import { Vue, Component, Prop } from 'vue-property-decorator'
import { FormModel, InvalidFields } from '@/components/common/form/types'
import { ElForm } from 'element-ui/types/form'
import { TCWClientValidationError, TCWUnexpectedError } from '@/plugins/TCWBaseError'

@Component
export default class TcwForm extends Vue {
  @Prop({
    default: () => {
      return {}
    }
  })
  private form!: FormModel
  @Prop({ type: Number, default: 9 })
  private width!: number
  @Prop({ default: null })
  private position!: 'left' | 'right' | 'top' | null
  @Prop({ type: Boolean, default: false })
  private inline!: boolean

  private get labelPosition(): string {
    if (this.position) {
      return this.position
    }
    return this.$mq === 'sp' ? 'top' : 'right'
  }

  public validate(): Promise<FormModel> {
    const elForm: ElForm = this.$refs.form as ElForm
    if (elForm && elForm.validate) {
      return new Promise((resolve, reject) => {
        elForm.validate(
          // eslint-disable-next-line @typescript-eslint/ban-types
          (isValid: boolean, invalidFields: object) => {
            if (isValid) {
              resolve(this.form)
            } else {
              const error = new TCWClientValidationError(
                '入力エラーを修正してください',
                invalidFields as InvalidFields
              )
              reject(error)
            }
          }
        )
      })
    } else {
      return Promise.reject(new TCWUnexpectedError(''))
    }
  }
}
